import { WSAlert, WSList, WSText } from "@wingspanhq/fe-component-library";
import { InsuranceCoverage } from "@wingspanhq/wingspan-api-sdk";

import { CollapsibleItem } from "../../../../shared/components/CollapsibleItem/CollapsibleItem";
import { DataViewGrid } from "../../../../shared/components/DataView";
import { selectorPolicyTypeByPolicyType } from "../../../MyResources/selectors/selectorPolicyTypeByPolicyType";
import { mapInsuranceCoverageToDataView } from "../../modules/SharedFile/configs/helpers/mapInsuranceCoverageToDataView";
import { selectorInsuranceCoverageIssues } from "../../selectors/selectorInsuranceCoverageIssues";

export const Policies: React.FC<{
  coverages: InsuranceCoverage[];
}> = ({ coverages }) => {
  return (
    <WSList gap="XL">
      {coverages.map((coverage, index) => {
        const issues = selectorInsuranceCoverageIssues(coverage);
        const policyTypeLabel = selectorPolicyTypeByPolicyType(
          coverage.policyType
        );

        return (
          <CollapsibleItem
            key={index}
            avatarProps={{
              icon: "file",
              type: "icon"
            }}
            isExpanded={true}
            subtitle={coverage.title ? policyTypeLabel : undefined}
            title={`Policy ${index + 1}: ${
              coverage.title || policyTypeLabel || "Unknown policy type"
            }`}
          >
            {issues.length > 0 ? (
              <WSAlert icon="alert-circle" mb="L" theme="error">
                {issues.map(issue => (
                  <WSText.ParagraphSm key={issue.message} color="gray500">
                    {issue.message}
                  </WSText.ParagraphSm>
                ))}
              </WSAlert>
            ) : (
              <WSAlert icon="check-circle" mb="L" theme="success">
                Policy is ready to be imported.
              </WSAlert>
            )}

            <DataViewGrid data={mapInsuranceCoverageToDataView(coverage)} />
          </CollapsibleItem>
        );
      })}
    </WSList>
  );
};
